import { FunnelStep } from "../FunnelStep";
import { flightStep } from "./flightStep";
import { optionsStep } from "./optionsStep";
import { paymentStep } from "./paymentStep";
import { transferStep } from "./transferStep";
import { userInfoStep } from "./UserInfoStep";
import { trainStep } from "./trainStep";
// import { errorStep } from "./ErrorStep";


export const funnelSteps: FunnelStep[] = [flightStep, transferStep, optionsStep, userInfoStep, paymentStep, trainStep];
